import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import { space } from 'styled-system';

import type { SpaceProps } from '../../theme/system-types';
import ResponsiveImage from '../ResponsiveImage';

interface ImageProps {
  url: string;
  name: string;
}

const SIZE_S = 180;
const SIZE_M = 202;
const SIZE_L = 222;
const SIZE_XL = 264;
export const WIDTHS = [SIZE_S, SIZE_M, SIZE_M, SIZE_L, SIZE_XL];

const StyledImage = styled(ResponsiveImage)<SpaceProps>`
  ${space};
`;

const styledImageStyles: Partial<ComponentProps<typeof StyledImage>> = {
  mr: 'sp_4',
};

const Image = ({ url, name }: ImageProps) => {
  return <StyledImage {...styledImageStyles} src={url} widths={WIDTHS} alt={name} isLazy />;
};

export default Image;
